import React from 'react';
import useInput from "../../hooks/useInput";
import {IInput} from "interfaces/index";
import {useTranslation} from "react-i18next";
import TextField from "../../ui/material-kit/TextField";
import styled from "styled-components";
import HeaderOneMobile from "../customText/headers/HeaderOne.mobile";
import {regexOnlyNumbers} from "../../constants/validations";

interface TitleProps {
    title: string
}

export const Title = (props: TitleProps): JSX.Element => {
    const {title} = props
    return (
        <>
            <TitleText>
                {title}
            </TitleText>
        </>
    )
}

const TitleText = styled(HeaderOneMobile)`
  color: ${({theme}) => theme.palette.color.main};  
  text-transform: uppercase;
  margin-bottom: 40px;

  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.palette.background.mobile_title};
`

interface PhoneProps {
    phoneNumber: IInput,
}

export const Phone = (props: PhoneProps): JSX.Element => {
    const {t} = useTranslation();
    const {phoneNumber} = props
    const phoneCode = useInput('+216')

    return (
        <Wrapper>
            <TextField
                {...phoneCode} readOnly placeholder={t(`common.registration.phone.code`)}
                upContent={t(`common.registration.phone.title`)} required
                id={'recovery_password_phone_code_input'}
                extra={'width: 60px;'} inputExtra={'& > input { padding: 10px;}'}
            />
            <TextField  {...phoneNumber}
                        placeholder={t(`common.registration.phone.number`)} required
                        regex={regexOnlyNumbers}
                        id={'recovery_password_phone_input'}
                        inputProps={{maxLength: 8}}/>
        </Wrapper>
    )
}

export const Email = ({email}: { email: IInput }) => {
    const {t} = useTranslation();
    return (
        <>
            <TextField
                {...email} upContent={t(`common.registration.email`)}
                id={'recovery_password_email_input'}
            />
        </>
    )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;

  & > * + * {
    margin-left: 10px;
  }
`
